export const itemTypes = [
  {
    name: "Blog Post",
    key: "blogPost",
    id: 1,
    noodleTools: "Blog",
  },
  {
    name: "Web Page",
    key: "webpage",
    id: 2,
    noodleTools: "Website",
  },
  {
    name: "Artwork",
    key: "artwork",
    id: 4,
    noodleTools: "Work of Visual Art",
  },
  {
    name: "Attachment",
    key: "attachment",
    id: 5,
    noodleTools: "Digital File",
  },
  {
    name: "Audio Recording",
    key: "audioRecording",
    id: 6,
    noodleTools: "Sound Recording, Published",
  },
  {
    name: "Bill",
    key: "bill",
    id: 7,
    noodleTools: "Bill or Resolution (U.S.)",
  },
  {
    name: "Book",
    key: "book",
    id: 8,
    noodleTools: "Book",
  },
  {
    name: "Book Section",
    key: "bookSection",
    id: 9,
    noodleTools: "Anthology/Collection",
  },
  {
    name: "Case",
    key: "case",
    id: 10,
    noodleTools: "Court Case",
  },
  {
    name: "Computer Program",
    key: "computerProgram",
    id: 11,
    noodleTools: "Software",
  },
  {
    name: "Conference Paper",
    key: "conferencePaper",
    id: 12,
    noodleTools: "Conference Proceedings, Published (Book/Anthology)",
  },
  {
    name: "Dataset",
    key: "dataset",
    id: 13,
    noodleTools: "Unpublished Paper or Data",
  },
  {
    name: "Dictionary Entry",
    key: "dictionaryEntry",
    id: 14,
    noodleTools: "Reference Source",
  },
  {
    name: "Document",
    key: "document",
    id: 15,
    noodleTools: "Report (Technical/Research)",
  },
  {
    name: "Email",
    key: "email",
    id: 16,
    noodleTools: "E-Mail",
  },
  {
    name: "Encyclopedia Article",
    key: "encyclopediaArticle",
    id: 17,
    noodleTools: "Reference Source",
  },
  {
    name: "Film",
    key: "film",
    id: 18,
    noodleTools: "Television or Radio Program",
  },
  {
    name: "Forum Post",
    key: "forumPost",
    id: 19,
    noodleTools: "Web Forum (Message Board)",
  },
  {
    name: "Hearing",
    key: "hearing",
    id: 20,
    noodleTools: "Committee Hearing and Testimony (U.S.)",
  },
  {
    name: "Instant Message",
    key: "instantMessage",
    id: 21,
    noodleTools: "Digital File",
  },
  {
    name: "Interview",
    key: "interview",
    id: 22,
    noodleTools: "Interview",
  },
  {
    name: "Journal Article",
    key: "journalArticle",
    id: 23,
    noodleTools: "Journal",
  },
  {
    name: "Letter",
    key: "letter",
    id: 24,
    noodleTools: "Unpublished Paper or Data",
  },
  {
    name: "Magazine Article",
    key: "magazineArticle",
    id: 25,
    noodleTools: "Magazine",
  },
  {
    name: "Manuscript",
    key: "manuscript",
    id: 26,
    noodleTools: "Unpublished Paper or Data",
  },
  {
    name: "Map",
    key: "map",
    id: 27,
    noodleTools: "Map or Chart (Born Digital)",
  },
  {
    name: "Newspaper Article",
    key: "newspaperArticle",
    id: 28,
    noodleTools: "Newspaper",
  },
  {
    name: "Patent",
    key: "patent",
    id: 30,
    noodleTools: "Patent (U.S.)",
  },
  {
    name: "Podcast",
    key: "podcast",
    id: 31,
    noodleTools: "Audio Podcast",
  },
  {
    name: "Preprint",
    key: "preprint",
    id: 32,
    noodleTools: "Unpublished Paper or Data",
  },
  {
    name: "Presentation",
    key: "presentation",
    id: 33,
    noodleTools: "Performance",
  },
  {
    name: "Radio Broadcast",
    key: "radioBroadcast",
    id: 34,
    noodleTools: "Television or Radio Program",
  },
  {
    name: "Report",
    key: "report",
    id: 35,
    noodleTools: "Report (Technical/Research)",
  },
  {
    name: "Standard",
    key: "standard",
    id: 36,
    noodleTools: "Report (Technical/Research)",
  },
  {
    name: "Statute",
    key: "statute",
    id: 37,
    noodleTools: "Statute (U.S.)",
  },
  {
    name: "Thesis",
    key: "thesis",
    id: 38,
    noodleTools: "Dissertation or Thesis",
  },
  {
    name: "Tv Broadcast",
    key: "tvBroadcast",
    id: 39,
    noodleTools: "Television or Radio Program",
  },
  {
    name: "Video Recording",
    key: "videoRecording",
    id: 40,
    noodleTools: "Video Clip (Online)",
  },
];
